export const cmpSetting = {
  ifUseModal: true,
  transferPersonSetting: {
    transferTabList: ['Organization', 'Role'],
    ifUseTabList: true,
    ifSelectDept: true,
    deptOnly: false,
    onlyStaticUserGroup: false,
    noPermission: false,
    useSelectAll: false
  },
  mainPageSetting: {
    useMainPage: true,
    useDisplayArea: true,
    useChooseModeRadio: true,
    useFucButtonGroup: true,
    useConfirmButtonGroup: true,
    useSelectTips: true,
    ifVertical: true,
    showAreaMaxWidth: 550
  }
};